<template>
    <ion-page>
        <standard-header title="All Picks" align="middle" />
        <ion-content :fullscreen="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-back-button></ion-back-button>
                </ion-buttons>
                <ion-buttons slot="secondary">
                    <ion-icon size="large" :icon="alertCircleOutline" />&nbsp;
                    <ion-button size="large" fill="outline" shape="round" color="danger">
                        <ion-badge size="large" color="danger">5</ion-badge>
                    </ion-button>
                </ion-buttons>
                <ion-title>ALERTS</ion-title>
            </ion-toolbar>
        </ion-content>
    </ion-page>
</template>

<script>
    import {IonPage, IonContent, IonIcon, IonTitle, IonBadge, IonToolbar, IonButton, IonButtons, IonBackButton} from '@ionic/vue';

    import StandardHeader from "@/components/StandardHeader.vue";

    import {alertCircleOutline} from 'ionicons/icons';

    export default {
        name: 'List',
        components: {
            StandardHeader,
            IonContent, IonPage, IonIcon, IonBadge, IonTitle, IonToolbar, IonButton, IonButtons, IonBackButton
        },
        methods: {

        },
        setup() {
            return {
                alertCircleOutline
            }
        }
    }
</script>

<style>

</style>
